export const products = [
    {
        name: "Docs Home",
        link: "/docs",
        version: []
    },
    {
        name: "Cloud",
        link: "/docs/latest/cloud/service-catalog/quick-start/",
        version: ["Latest"]
    },
    {
        name: "Edge Stack",
        link: "/docs/latest/tutorials/getting-started/",
        version: ["Pre-release", "Latest", "1.11", "1.10", "1.9", "1.8", "1.7", "1.6", "1.5", "1.4", "1.3"]
    },
    {
        name: "Telepresence",
        link: "/docs/latest/telepresence/quick-start/",
        version: ["Pre-release", "Latest", "2.0"]
    }
];